module.exports = __webpack_public_path__ + "static/media/header-image.38bb9955.webp";